import { render, staticRenderFns } from "./CadastrarEditarTurmaDialog.vue?vue&type=template&id=9ecf6bf4"
import script from "./CadastrarEditarTurmaDialog.vue?vue&type=script&lang=js"
export * from "./CadastrarEditarTurmaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports